import * as React from 'react';
import { rectIcon } from '../data/icon';
import { assert } from '../../lib/utils';

export default function ({ icon, onSelect }: {
    icon: rectIcon,
    onSelect: (e: React.MouseEvent, command: string) => void,
}) {
    return (
    <div
        style={{
            position: 'absolute',
            left: `${icon.left}px`,
            top: `${icon.top}px`,
            width: `${icon.width}px`,
            height: `${icon.height}px`,
            opacity: 0,
        }}
        onClick={e => {
            assert(typeof icon.command === 'string', '');
            onSelect(e, icon.command);
        }}
    />);
}
